import { SelectOption } from '@root/components/Form/Select';
import classNames from 'classnames';
import { useField, useFormikContext } from 'formik';
import React, { useMemo, useState } from 'react';
import { Dropdown, FormControl } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';

type CustomToggleProps = {
    children?: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {};
};

const CustomToggle = React.forwardRef(
    (
        { children, onClick }: CustomToggleProps,
        ref: React.Ref<HTMLAnchorElement>,
    ) => (
        <a
            href=""
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                if (onClick) {
                    onClick(e);
                }
            }}
        >
            {children}
            &#x25bc;
        </a>
    ),
);

type CustomMenuProps = {
    children?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
    labeledBy?: string;
};

const CustomMenu = React.forwardRef(
    (
        { children, style, className, labeledBy }: CustomMenuProps,
        ref: React.Ref<HTMLDivElement>,
    ) => {
        const { t } = useTranslation('userRegistration');
        const [value, setValue] = useState('');

        return (
            <div
                ref={ref}
                style={style}
                className={classNames(className, styles.dropdownMenu)}
                aria-labelledby={labeledBy}
            >
                <FormControl
                    autoFocus
                    placeholder={t('form.countrySearchPlaceholder', {
                        defaultValue: "Ieškoti šalies",
                    })}
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                />
                <ul className="list-unstyled">
                    {React.Children.toArray(children).filter(
                        (child) =>
                            !value ||
                            (child as any).props.children
                                .toLowerCase()
                                .startsWith(value),
                    )}
                </ul>
            </div>
        );
    },
);

type CountryProps = {
    countries: SelectOption[];
};

const Country = ({ countries }: CountryProps) => {
    const { setFieldValue } = useFormikContext();
    const [{ value }] = useField('country');
    const choosedCountry = useMemo(() => {
        if (countries.length === 0) {
            return undefined;
        }
        const country = countries.find((country) => country.value === parseInt(value, 10))
        if (!country) {
            return countries[0]
        }
        return country
    }, [countries, value]);
    return (
        <Dropdown
            className={styles.country_dropdown}
            onSelect={(eventKey) => {
                setFieldValue('country', eventKey);
            }}
        >
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                {choosedCountry ? choosedCountry.label : '-'}
            </Dropdown.Toggle>

            <Dropdown.Menu as={CustomMenu}>
                {countries.map((country) => (
                    <Dropdown.Item key={country.value} eventKey={country.value} active={choosedCountry?.value === country.value ? true : false}>
                        {country.label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default Country;
